<a href="javascript:void(0);" class="d-flex align-items-center text-nowrap text-decoration-none text-grad fs-5" (click)="toggle()">
    <span class="name" *ngIf="customer">Olá, {{ customer.name.split(' ')[0] }}</span>
    <i class="las la-user-circle ms-1"></i>
</a>

<div class="menu" [ngClass]="{ show: show, hide: !show }" >
    <div class="item" role="button" [routerLink]="['/my-profile']" (click)="toggle()">
        <i class="las la-user text-grad me-2"></i> Meu Perfil
    </div>
    <div 
      class="item"
      role="button"
      [routerLink]="['/reconhecimento-facial']"
      (click)="toggle()"
      *ngIf="enableFacialRecognition"
    >
      <i class="las la-smile text-grad me-2"></i> Reconhecimento facial
    </div>
    <div *ngIf="comissionerMode == false else showMySells">
      <div class="item" role="button" [routerLink]="['/my-orders']" (click)="toggle()">
          <i class="las la-ticket-alt text-grad me-2"></i> Meus Pedidos
      </div>
    </div>
    <ng-template #showMySells>
      <div class="item" role="button" [routerLink]="['/my-sells']" (click)="toggle()">
          <i class="las la-ticket-alt text-grad me-2"></i> Minhas vendas
      </div>
    </ng-template>
    <div class="item" role="button" (click)="logOut()">
        <i class="las la-power-off text-grad me-2"></i> Sair
    </div>
</div>
<div *ngIf="hasComissioner == true">
  <div class="form-check form-switch">
    <input class="form-check-input" (click)="modeComissioner()" [checked]="comissionerMode == true" type="checkbox" role="switch" id="flexSwitchCheckDefault">
    <label class="form-check-label" for="flexSwitchCheckDefault">Comissário</label>
  </div>
</div>
<bs-modal-backdrop class="modal-backdrop fade in show" (click)="toggle()" *ngIf="show"></bs-modal-backdrop>
